import type { MotionPoint } from "./motionSeries";

export type GripperSegment = {
  start: number;
  end: number;
  open: boolean;
};

/** 원본 표본의 상태 전환으로 구간을 만든다. 결측 구간을 이어 붙이지 않는다. 마지막 표본 뒤를 추정하지 않는다. */
export function gripperSegments(
  points: readonly MotionPoint[],
  threshold: number,
  openAbove: boolean,
): GripperSegment[] {
  if (!Number.isFinite(threshold)) return [];
  const segments: GripperSegment[] = [];
  for (let index = 0; index < points.length - 1; index += 1) {
    const point = points[index]!;
    const next = points[index + 1]!;
    if (point.v === null || next.t <= point.t) continue;
    // 임계값과 같은 값은 선택한 방향에 관계없이 열림에 포함한다.
    const open = openAbove ? point.v >= threshold : point.v <= threshold;
    const previous = segments[segments.length - 1];
    if (previous?.open === open && previous.end === point.t) previous.end = next.t;
    else segments.push({ start: point.t, end: next.t, open });
  }
  return segments;
}
